document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.toggle-wrapper').forEach(wrapper => {
    const moreBtn = wrapper.querySelector('.icon-more');
    const lessBtn = wrapper.querySelector('.icon-less');
    const desc = wrapper.querySelector('.text-open__item-description');
    const img = wrapper.querySelector('.text-open__image');

    const updateState = () => {
      const isOpen = desc.classList.toggle('is-open');
      desc.classList.toggle('is-closed', !isOpen);

      moreBtn.classList.toggle('hidden', isOpen);
      lessBtn.classList.toggle('hidden', !isOpen);
      img.classList.toggle('expanded', isOpen);
    };

    moreBtn.addEventListener('click', updateState);
    lessBtn.addEventListener('click', updateState);
  });
});
